import styled, { css, keyframes } from 'styled-components';

import { rem } from '../../utils';

const LoaderAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const StyledRoundSpinner = styled.div`
  ${({ theme }) => css`
    border: ${rem(theme.Components.Spin.Round.Size)} solid ${theme.Color.Neutrals.Border};
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: ${LoaderAnimation} 1s linear infinite;
    border-bottom-color: ${theme.Color.Brand.Primary};
  `}
`;
